import {
  PREDES_TRANSACTIONS_REJECT_REQUEST,
  PREDES_TRANSACTIONS_REJECT_SUCCESS,
  PREDES_TRANSACTIONS_REJECT_FAILURE,
  PREDES_TRANSACTIONS_BULK_REJECT_REQUEST,
  PREDES_TRANSACTIONS_BULK_REJECT_SUCCESS,
  PREDES_TRANSACTIONS_BULK_REJECT_FAILURE,
} from './types/PredesTransactionsRejectActionsTypes';

export function postPredesTransactionsRejectRequestActionCreator(context,
  newComments,
  newTransactionId) {
  return {
    type: PREDES_TRANSACTIONS_REJECT_REQUEST,
    payload: {
      appContext: context,
      params: {
        comment: newComments,
        transactionIds: newTransactionId,
      },
    },
  };
}

export function postPredesTransactionsRejectSuccessActionCreator(data) {
  return {
    type: PREDES_TRANSACTIONS_REJECT_SUCCESS,
    payload: data,
  };
}

export function postPredesTransactionsRejectFailureActionCreator(error) {
  return {
    type: PREDES_TRANSACTIONS_REJECT_FAILURE,
    payload: error,
    error: true,
  };
}

export function postPredesTransactionsBulkRejectRequestActionCreator(context,
  selectedTransactionIds) {
  return {
    type: PREDES_TRANSACTIONS_BULK_REJECT_REQUEST,
    payload: {
      appContext: context,
      params: {
        transactionIds: selectedTransactionIds,
      },
    },
  };
}

export function postPredesTransactionsBulkRejectSuccessActionCreator(data) {
  return {
    type: PREDES_TRANSACTIONS_BULK_REJECT_SUCCESS,
    payload: data,
  };
}

export function postPredesTransactionsBulkRejectFailureActionCreator(error) {
  return {
    type: PREDES_TRANSACTIONS_BULK_REJECT_FAILURE,
    payload: error,
    error: true,
  };
}
